import Component from './components/StartUp';
import { PATH } from './constants';

export { PATH };
export default Component;
